import { useRouter } from "@shared/client/navigation";
import { useTransition } from "react";
import { LoaderCircle, RefreshCw } from "lucide-react";
import { Button } from "@shared/components/ui/button";

export function RefreshButton() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return (
    <Button
      disabled={pending}
      onClick={() => startTransition(() => router.refresh())}
      size="sm"
      type="button"
      variant="outline"
    >
      {pending ? <LoaderCircle className="animate-spin" /> : <RefreshCw />} Actualiser
    </Button>
  );
}
